import React, { Component } from "react";
import { connect } from "react-redux";
import { Field, reduxForm, reset } from "redux-form";
import _ from "lodash";
import Button from "react-bootstrap-button-loader";
import { CopyToClipboard } from "react-copy-to-clipboard";
import { BaseComponent, LABEL_POSITION_TOP } from "BaseComponent";
import { Modal } from "react-bootstrap";
import { showError, showSuccess } from "ReduxErrorBar";
import {
  openEventPolicyTypeModal,
  fetchEventDetails,
} from "DashboardUserAction";
import { fetchSettings, addSetting, updateSetting } from "TicketAction";
import { COMMON_FAIL_MESSAGE, validateUrl, DOMAIN_NAME } from "Constants";
import LocaleStrings from "Languages";

class EventPolicySetting extends Component {
  constructor(props) {
    super(props);
    this.closeModal = this.closeModal.bind(this);
    this.openModal = this.openModal.bind(this);
    this.onSubmitForm = this.onSubmitForm.bind(this);
    this.state = { loading: false, copied: false };
  }

  componentDidMount() {
    this.props.fetchSettings(this.props.session);
    this.props.fetchEventDetails(this.props.session);
  }

  openModal() {
    this.props.reset();
    this.setState({ loading: false });
    this.props.openEventPolicyTypeModal(true);
  }

  closeModal() {
    this.props.reset();
    this.props.openEventPolicyTypeModal(false);
  }

  onSubmitForm(data) {
    // console.log("data :- ", data);
    var values = {};
    values.eventpolicytype = data.eventpolicytype;
    if (data.eventpolicytype === "external_registration_link") {
      values.external_registration_url = data.external_registration_url;
    } else if (data.eventpolicytype === "public_without_reg") {
      values.isloginmandatory = 0;
    }

    this.setState({ loading: true });
    if (!this.props.editMode) {
      // Add
      this.props.addSetting(this.props.session, values, (response) => {
        if (response.success === 0) {
          this.setState({ loading: false });
          this.props.showError(COMMON_FAIL_MESSAGE);
        } else {
          this.setState({ loading: false });
          this.props.showSuccess(
            LocaleStrings.user_event_policy_form_policy_added_success
          );
          this.closeModal();
        }
      });
    } else {
      // Edit
      values.id = data.id;
      this.props.updateSetting(values, this.props.session, (response) => {
        if (response.success === 0) {
          this.setState({ loading: false });
          this.props.showError(COMMON_FAIL_MESSAGE);
        } else {
          this.setState({ loading: false });
          this.props.showSuccess(
            LocaleStrings.user_event_policy_form_policy_updated_success
          );
          this.closeModal();
        }
      });
    }
  }

  copyUrl = () => {
    this.setState({ copied: true });

    setTimeout(() => {
      this.setState({ copied: false });
    }, 500);
  };

  render() {
    var {
      handleSubmit,
      pristine,
      reset,
      submitting,
      invalid,
      editMode,
      eventDetails,
      initialValues,
    } = this.props;
    var policyType = "";
    var displayUrlSection = false;
    var link = "";
    if (
      initialValues &&
      initialValues.eventpolicytype == "public_with_ticket"
    ) {
      policyType =
        LocaleStrings.user_event_policy_form_label_policy_type_option4;
      displayUrlSection = true;
      link = "tickets";
    } else if (
      initialValues &&
      initialValues.eventpolicytype == "public_with_reg"
    ) {
      policyType =
        LocaleStrings.user_event_policy_form_label_policy_type_option3;
      displayUrlSection = true;
      link = "register";
    } else if (
      initialValues &&
      initialValues.eventpolicytype == "public_without_reg"
    ) {
      policyType =
        LocaleStrings.user_event_policy_form_label_policy_type_option2;
    } else if (
      initialValues &&
      initialValues.eventpolicytype == "external_registration_link"
    ) {
      policyType =
        LocaleStrings.user_event_policy_form_label_policy_type_option1;
      displayUrlSection = true;
    }

    let seocode =
      eventDetails && eventDetails.seocode
        ? eventDetails.seocode
        : "not-found-seocode";
    var registrationUrl = `https://${seocode}.${DOMAIN_NAME}/t/${link}`;

    if (
      initialValues &&
      initialValues.eventpolicytype == "external_registration_link"
    ) {
      registrationUrl = initialValues.external_registration_url;
    }

    return (
      <div className="row">
        <div className="col-md-12" style={{ marginBottom: 20 }}>
          <span className="pull-left" style={{ fontWeight: "bold" }}>
            {policyType}
          </span>
          <span className="pull-right">
            <button
              type="button"
              className="btn btn-custom-white"
              onClick={this.openModal}
            >
              <i className="fa fa-cog i-custom-m" aria-hidden="true"></i>
              {LocaleStrings.button_user_registration_policy}
            </button>
          </span>
        </div>

        {displayUrlSection ? (
          <div className="col-md-12">
            <div className="ticket-dashboard-ticket-created-page-main-div">
              <h4 className="heading-para">
                {policyType == "Ticket"
                  ? LocaleStrings.tickets_dashboard_text_ticket_page_created
                  : LocaleStrings.user_registration_policy_text_registration_page_created}
              </h4>
              <p className="promote-para">
                {policyType == "Ticket"
                  ? LocaleStrings.tickets_dashboard_text_ticket_page_created_sub_title
                  : LocaleStrings.user_registration_policy_text_registration_page_created_sub_title}
              </p>
              <div className="vertical-align-center gap-2">
                <div className="">
                  <div
                    className="copy-ticket-page copyticketab"
                    style={{ width: 508 }}
                  >
                    <div className="ticket-url">{registrationUrl}</div>
                    <CopyToClipboard
                      text={registrationUrl}
                      onCopy={this.copyUrl}
                    >
                      <div
                        className="url-copy"
                        style={{ padding: "10px 34px" }}
                      >
                        <i
                          className="fa fa-files-o i-custom-m"
                          aria-hidden="true"
                        ></i>
                        {this.state.copied ? (
                          <>
                            <span style={{ color: "green" }}>
                              {LocaleStrings.copied}
                            </span>
                          </>
                        ) : (
                          <>
                            <span>{LocaleStrings.button_copy}</span>
                          </>
                        )}
                      </div>
                    </CopyToClipboard>
                  </div>
                </div>
                <div className="">
                  <a
                    href={registrationUrl}
                    target="blank"
                    className="btn btn-custom-blue"
                  >
                    <span aria-hidden="true">{LocaleStrings.button_visit}</span>
                  </a>
                </div>
              </div>
            </div>
          </div>
        ) : (
          " "
        )}

        <div>
          <Modal
            dialogClassName="user-registration-policy-modal"
            show={this.props.showModal === true ? true : false}
            onHide={this.closeModal}
            animation={true}
          >
            <form
              onSubmit={handleSubmit(this.onSubmitForm)}
              encType="multipart/form-data"
            >
              <Modal.Header>
                <div className="import-modal-title">
                  {LocaleStrings.user_event_policy_text_set_event_policy_type}
                </div>
                <button
                  type="button"
                  className="i-custom-cross-popup pull-right"
                  onClick={() => this.closeModal()}
                >
                  <img
                    className="i-custom-small"
                    src="../../style/images/custom-icons/cross-black.png"
                  />
                </button>
              </Modal.Header>
              <Modal.Body>
                <div>
                  <EventPolicyForm
                    editMode={editMode}
                    initialValues={this.props.initialValues}
                    {...this.props}
                  />
                </div>

                {/* <ul className="p-0" > */}
                <div className="form-group row">
                  <label className="control-label-top col-sm-12">
                    {LocaleStrings.user_event_policy_form_text_note}
                  </label>
                  {/* <h5>Policy types Descriptions :- </h5> */}
                  <ul className="pl-30">
                    <li>
                      <b>
                        {
                          LocaleStrings.user_event_policy_form_label_policy_type_option1
                        }{" "}
                        :-
                      </b>{" "}
                      {LocaleStrings.user_event_policy_form_note_external_link}
                    </li>
                    <li>
                      <b>
                        {
                          LocaleStrings.user_event_policy_form_label_policy_type_option2
                        }{" "}
                        :-
                      </b>{" "}
                      {LocaleStrings.user_event_policy_form_note_without_reg}
                    </li>
                    <li>
                      <b>
                        {
                          LocaleStrings.user_event_policy_form_label_policy_type_option3
                        }{" "}
                        :-
                      </b>{" "}
                      {LocaleStrings.user_event_policy_form_note_with_reg}
                    </li>
                    <li>
                      <b>
                        {
                          LocaleStrings.user_event_policy_form_label_policy_type_option4
                        }{" "}
                        :-
                      </b>{" "}
                      {LocaleStrings.user_event_policy_form_note_ticket}
                    </li>
                  </ul>
                </div>
                {/* </ul> */}
              </Modal.Body>
              <Modal.Footer>
                <Button
                  className="btn btn-custom-white"
                  onClick={this.closeModal}
                >
                  {LocaleStrings.button_close}
                </Button>
                <Button
                  className="btn btn-custom-blue ml-10"
                  loading={this.state.loading}
                  disabled={pristine || invalid || submitting}
                  type="submit"
                >
                  {LocaleStrings.button_save}
                </Button>
              </Modal.Footer>
            </form>
          </Modal>
        </div>
      </div>
    );
  }
}

function mapStateToProps(state) {
  var initVals = null;
  var toEdit = false;

  if (
    state.SettingData &&
    state.SettingData.resource &&
    state.SettingData.resource.length > 0
  ) {
    initVals = state.SettingData.resource[0];
    toEdit = true;
  }

  return {
    session: state.session,
    showModal: state.ShowEventPolicyTypeModal,
    initialValues: initVals,
    editMode: toEdit,
    eventDetails: state.userEventDetails,
  };
}

function validate(values) {
  var errors = {};
  var policytype = values["eventpolicytype"];
  var url = values["external_registration_url"];

  if (policytype === "") {
    errors["eventpolicytype"] =
      LocaleStrings.user_event_policy_form_validation_required;
  }

  if (policytype && policytype === "external_registration_link" && !url) {
    errors["external_registration_url"] =
      LocaleStrings.user_event_policy_form_validation_required;
  }

  if (
    policytype &&
    policytype === "external_registration_link" &&
    url &&
    !validateUrl(url)
  ) {
    errors["external_registration_url"] =
      LocaleStrings.user_event_policy_form_validation_invalid_url;
  }
  return errors;
}

export default connect(mapStateToProps, {
  openEventPolicyTypeModal,
  fetchSettings,
  addSetting,
  updateSetting,
  fetchEventDetails,
  showError,
  showSuccess,
})(
  reduxForm({
    validate,
    form: "EventPolicyTypeForm",
    enableReinitialize: true,
    keepDirtyOnReinitialize: true,
  })(EventPolicySetting)
);

class EventPolicyForm extends BaseComponent {
  constructor(props) {
    super(props);
    this.state = {
      isExternalUrl: false,
    };
  }

  componentDidMount() {
    if (this.props.editMode) {
      if (
        this.props.initialValues &&
        this.props.initialValues.eventpolicytype &&
        this.props.initialValues.eventpolicytype ===
          "external_registration_link"
      ) {
        this.setState({ isExternalUrl: true });
      }
    }
  }

  policyTypeChange = (e) => {
    let changepolicy = e.target.value;

    if (changepolicy === "external_registration_link") {
      this.setState({ isExternalUrl: true });
    } else {
      this.setState({ isExternalUrl: false });
    }
  };

  render() {
    let { isExternalUrl } = this.state;
    let categories = [
      {
        name: LocaleStrings.user_event_policy_form_label_policy_type_option1,
        value: "external_registration_link",
      },
      {
        name: LocaleStrings.user_event_policy_form_label_policy_type_option2,
        value: "public_without_reg",
      },
      {
        name: LocaleStrings.user_event_policy_form_label_policy_type_option3,
        value: "public_with_reg",
      },
      {
        name: LocaleStrings.user_event_policy_form_label_policy_type_option4,
        value: "public_with_ticket",
      },
    ];

    return (
      <div className="basicform">
        <Field
          name="eventpolicytype"
          label={LocaleStrings.user_event_policy_form_label_policy_type}
          placeholder={LocaleStrings.user_event_policy_form_ph_policy_type}
          type="select"
          component={this.renderSelect}
          opts={categories}
          onChange={this.policyTypeChange}
          labelposition={LABEL_POSITION_TOP}
        />
        {isExternalUrl ? (
          <Field
            name="external_registration_url"
            label={LocaleStrings.user_event_policy_form_label_external_url}
            placeholder={LocaleStrings.user_event_policy_form_ph_external_url}
            type="text"
            component={this.renderFieldText}
            mandatory="true"
            labelposition={LABEL_POSITION_TOP}
          />
        ) : (
          ""
        )}
      </div>
    );
  }
}
